import {useState} from 'react';
import {t} from 'i18next';
import { Box, Typography } from '@mui/material';
import AurDialog, {DialogProps} from '../../../common/aur-dialog/AurDialog';
import {ALPHANUMERIC_DASH} from '../../../../constants/constants';
import {AurTextField} from '../../../common/aur-text-field/AurTextField';
import AurLoadingIndicator from '../../../common/aur-loading-indicator/AurLoadingIndictor';

interface AddCustodianProps {
  showDialog: DialogProps['showDialog'];
  onOk: (data: {firstName: string; lastName: string}) => void;
  onCancel: DialogProps['onCancel'];
  isLoading: boolean;
}

const AddCustodianModel = ({
  showDialog,
  onOk,
  onCancel,
  isLoading = false
}: AddCustodianProps) => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [errors, setErrors] = useState<{firstName?: string; lastName?: string}>(
    {}
  );

  const validateAndSetName = (
  field: 'firstName' | 'lastName',
  value: string
) => {
  if (field === 'firstName') {
    setFirstName(value);
  } else {
    setLastName(value);
  }

  let error = '';

  if (value === '') {
    error = `${field === 'firstName' ? 'First name' : 'Last name'} is required`;
  } else if (!ALPHANUMERIC_DASH.test(value)) {
    error = t('uploadEvidence.addCustodianModel.specialChar');
  }

  setErrors((prev) => ({
    ...prev,
    [field]: error,
  }));
};

  const isFormValid =
    firstName.trim() &&
    lastName.trim() &&
    !errors.firstName &&
    !errors.lastName;

  const handleAdd = () => {
    onOk({
      firstName: firstName.trim(),
      lastName: lastName.trim(),
    });
  };

  const renderContent = () => (
    <div className="add-custodian-content popup-dialog-content-body-text">
      <Typography
        tabIndex={0}
        className="typo-text headline3_size add-custodian-title"
        role="heading"
        aria-level={3}
      >
        {t('uploadEvidence.addCustodianModel.addCustodian')}
      </Typography>

      <Typography tabIndex={0} className="typo-text body2_size description">
        {t('uploadEvidence.addCustodianModel.addCustodianDesc')}
      </Typography>

      <AurTextField
        required
        label={t('uploadEvidence.addCustodianModel.firstName')}
        className="text-field"
        variant="filled"
        value={firstName}
        onChange={(e) => validateAndSetName('firstName', e.target.value)}
        error={Boolean(errors.firstName)}
        helperText={errors.firstName}
        ariaLabel={t('uploadEvidence.addCustodianModel.firstName')}
        inputProps={{maxLength: 50}}
      />

      <AurTextField
        required
        label={t('uploadEvidence.addCustodianModel.lastName')}
        className="text-field"
        variant="filled"
        value={lastName}
        onChange={(e) => validateAndSetName('lastName', e.target.value)}
        error={Boolean(errors.lastName)}
        helperText={errors.lastName}
        inputProps={{maxLength: 50}}
        ariaLabel={t('uploadEvidence.addCustodianModel.lastName')}
      />
       <Box className="loading-indicator">
          <AurLoadingIndicator show={isLoading} />
        </Box>
    </div>
  );

  return (
    <AurDialog
      showDialog={showDialog}
      className="add-custodian-dialog confirmation-popup-modal popup"
      popupContent={renderContent()}
      labelActionCancel={t('buttons.close')}
      labelActionOk={t('buttons.add')}
      onCancel={onCancel}
      onOk={handleAdd}
      onOkDisabled={!isFormValid || isLoading}
    />
  );
};

export default AddCustodianModel;
